// components/Sidebar.jsx
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Plane, X, LogOut } from 'lucide-react';
import useGlobale from '../../components/global';

const Sidebar = ({ isOpen, menuItems, onClose }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { authenticated, user, logout } = useGlobale();

    return (
        <>
            {/* Overlay for mobile */}
            {isOpen && (
                <div
                    className="fixed inset-0 bg-black/50 backdrop-blur-sm lg:hidden z-40"
                    onClick={onClose}
                    aria-hidden="true"
                />
            )}

            {/* Sidebar */}
            <aside
                className={`
                    fixed lg:static inset-y-0 left-0 
                    w-[280px] lg:w-64 
                    bg-white shadow-lg 
                    transform transition-transform duration-300 ease-in-out
                    ${isOpen ? 'translate-x-0' : '-translate-x-full'}
                    lg:translate-x-0 
                    z-50
                    flex flex-col
                    h-screen lg:h-auto
                    overflow-y-auto
                `}
            >
                {/* Mobile close button */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 lg:hidden p-2 rounded-lg hover:bg-[#F4F8E9] text-[#437011]"
                >
                    <X className="w-5 h-5" />
                </button>

                {/* Logo */}
                <div className="p-4 lg:p-6 border-b">
                    <div className="flex items-center space-x-3">
                        <Plane className="w-6 h-6 lg:w-8 lg:h-8 text-[#96B734]" />
                        <span className="text-xl lg:text-2xl font-bold text-[#437011]">NigerVoyage</span>
                    </div>
                </div>

                {/* Profile */}
                <div className="p-4 lg:p-6 bg-[#F4F8E9]">
                    <div className="flex items-center space-x-3">
                        <div className="relative">
                            <img
                                src="images/userp.jpg"
                                alt="Profile"
                                className="w-10 h-10 lg:w-12 lg:h-12 rounded-full border-2 border-[#96B734]"
                            />
                            <div className="absolute bottom-0 right-0 w-3 h-3 bg-[#96B734] rounded-full border-2 border-white"></div>
                        </div>
                        <div>
                            <h3 className="text-sm font-semibold text-[#437011]">{user.first_name} {user.last_name}</h3>
                            <p className="text-xs text-[#96B734]">Membre de Niger voyage</p>
                        </div>
                    </div>
                </div>

                {/* Navigation */}
                <nav className="flex-1 p-4 space-y-1">
                    {menuItems.map((item, index) => {
                        const isActive = location.pathname === item.path;
                        return (
                            <button
                                key={index}
                                onClick={() => {
                                    navigate(item.path);
                                    if (window.innerWidth < 1024) {
                                        onClose();
                                    }
                                }}
                                className={`
                                    flex items-center w-full
                                    px-3 py-2.5
                                    text-sm font-medium rounded-lg
                                    transition-colors duration-200
                                    ${isActive
                                        ? 'text-white bg-[#96B734] hover:bg-[#437011]'
                                        : 'text-gray-600 hover:bg-[#F4F8E9] hover:text-[#437011]'
                                    }
                                    focus:outline-none focus:ring-2 focus:ring-[#96B734] focus:ring-offset-2
                                `}
                            >
                                {React.cloneElement(item.icon, {
                                    className: `w-5 h-5 mr-3 flex-shrink-0 ${isActive ? 'text-white' : ''}`
                                })}
                                <span className="truncate">{item.label}</span>
                            </button>
                        );
                    })}
                </nav>

                {/* Déconnexion */}
                <div className="p-4 border-t mt-auto">
                    <button
                        onClick={logout}
                        className="
                            flex items-center w-full
                            px-3 py-2.5
                            text-sm font-medium text-red-600 
                            rounded-lg hover:bg-red-50 
                            transition-colors duration-200
                            focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2
                        "
                    >
                        <LogOut className="w-5 h-5 mr-3 flex-shrink-0" />
                        <span>Déconnexion</span>
                    </button>
                </div>
            </aside>
        </>
    );
};

export default Sidebar;